'use client';

import Link from 'next/link';

import BackgroundGradient from '@/components/elements/background-gradient';
import IconText2 from '@/components/elements/icon/icon-text2';
import { useTranslation } from '@/i18n/client';
import { WithLang } from '@/types/general';
import { PServiceCardS } from '@/types/polako-services';
import { AssetKey } from '@/utils/image-load-utils';
import { buildUrl } from '@/utils/navigation';

import ImageAsset from '../elements/image-asset';

export default function ServiceCardPromoted(
    props: WithLang<{
        service: PServiceCardS;
        assetKey: AssetKey;
    }>,
) {
    const { t: tCo } = useTranslation(props.lang, 'common');

    return (
        <div className="relative h-full overflow-hidden rounded-lg">
            <Link
                aria-label={`link to service ${props.service.name}`}
                className="cursor-pointer"
                href={buildUrl('services', { children: [props.service.slug || props.service.id] })}
                scroll={false}
            >
                <BackgroundGradient
                    ids={[props.service.gallery && props.service.gallery[0]?.image_file?.id]}
                    isAnimated={props.service.animated!}
                    filenameDisk={(props.service.gallery && props.service.gallery[0]?.image_file?.filename_disk) ?? ''}
                />
                <div className="mx-[5%] flex h-full justify-between md:ml-[5%]">
                    <div className="relative z-[1] my-4 flex flex-1 flex-col gap-y-4 text-white">
                        <div className="flex items-center gap-x-2 self-start rounded bg-white bg-opacity-20 p-2">
                            <IconText2
                                icon="phi-thumbs-up"
                                text={tCo('common.recommended')}
                                sizeSm={4}
                                sizeMd={6}
                                textClass="text-xs lg:text-lg"
                                iconClass="fill-white"
                            />
                        </div>
                        <p
                            className={`font-bold md:text-lg xl:text-xl xxl:text-2xl ${
                                props.service.name?.length > 50 ? 'text-[10px]' : 'text-sm'
                            }`}
                        >
                            {props.service.name}
                        </p>
                    </div>
                    <div className="relative flex-1">
                        <ImageAsset
                            priority={true}
                            ids={[props.service.gallery && props.service.gallery[0]?.image_file?.id]}
                            isAnimated={props.service.animated!}
                            filenameDisk={
                                (props.service.gallery && props.service.gallery[0]?.image_file?.filename_disk) ?? ''
                            }
                            assetKey={props.assetKey}
                        />
                    </div>
                </div>
            </Link>
        </div>
    );
}
